<template>
  <div class="checkbox-wrapper" :class="{ disable: isDisabled }">
    <div class="input-wrapper" :class="{ disable: isDisabled }">
      <div v-if="!isChecked" class="custom-checkbox" />
      <div v-if="isChecked" class="custom-checkbox-checked"></div>
      <img src="@/assets/icon/checked.svg" class="checked-icon" />
      <input
        :disabled="isDisabled"
        v-model="isChecked"
        type="checkbox" 
        @change="handleCheckbox()"
      />
    </div>
    <span class="label" v-html="checkboxLabel"></span>
  </div>
</template>

<script>
export default {
  props: {
    checkboxLabel: {
      default: ''
    },
    isDisabled: {
      default: false
    }
  },
  data() {
    return {
      isChecked: false
    };
  },
  watch: {
    isChecked() {
      this.$emit('onChecking', this.isChecked);
    }
  },
  methods: {
    handleCheckbox() {
      this.$emit('input', this.isChecked);
    }
  }
};
</script>

<style lang="scss" scoped>
.checkbox-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-family: Inter-Regular;
  font-size: 16px;
  color: #828c9f;
  &.disable {
    cursor: not-allowed;
    opacity: 0.8;
  }
  .input-wrapper {
    position: relative;
    width: 20px;
    height: 20px;
    cursor: pointer;
    &.disable {
      cursor: not-allowed;
      opacity: 0.8;
    }
    input {
      opacity: 0;
      width: 20px;
      height: 20px;
      cursor: pointer;
      &:disabled {
        cursor: not-allowed;
      }
    }
    .custom-checkbox,
    .custom-checkbox-checked {
      width: 20px;
      height: 20px;
      border-radius: 5px;
      border: 1px solid #f3f5fa;
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      background: #ffffff;
      bottom: 0;
      cursor: pointer;
    }
    .custom-checkbox-checked {
      background: #5b6ef5;
    }
    .checked-icon {
      position: absolute;
      top: 5px;
      right: 4px;
    }
  }
  .label {
    margin-left: 10px;
  }
}
</style>
